module.exports = __webpack_public_path__ + "components/flag/static/square/gt-6d5902f7747758cefc2aa2d6cb3767b8.svg";